import { UpdaterActionTypes } from '../actions/actionTypes';

export type TMsg = {
  type: 'meteo' | 'traffic';
};

export type TUpdater = {
  data: TMsg[];
};

const inititalState: TUpdater = {
  data: [] as TMsg[],
};

export default function updaterReducer(
  state = inititalState,
  action: UpdaterActionTypes,
) {
  switch (action.type) {
    default:
      return state;
    case 'RECEIVE_UPDATER_MSG':
      return {
        ...state,
        data: action.data,
      };
  }
}
